import { useEffect } from 'react';

import { DOM } from '@app/utils';
import { useOneTrust } from '@app/onetrust';
import { load } from '../../../client';

const handleOnConsentChange = (event) => {
  if (event.detail.includes('C0004')) {
    load();
  }
};

const useLoadSegment = () => {
  const [, isReady] = useOneTrust({
    onConsentChanged: handleOnConsentChange,
  });

  useEffect(() => {
    if (!isReady) {
      return;
    }

    if (
      window?.OptanonActiveGroups?.includes('C0004') ||
      DOM.getCookie<string>('OptanonConsent')?.includes('C0004:1')
    ) {
      load();
    }
  }, [isReady]);
};

export default useLoadSegment;
